import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import React from "react";

function ErrorDialog({ title = "Unexpected Error", defaultOpen, message, onClose, children, hideClose, maxWidth = "sm" }) {
    const [open, setOpen] = React.useState(defaultOpen);

    const handleClose = () => {
        setOpen(false);
        onClose();
    };

    return (
        <Dialog
            open={open}
            fullWidth={true}
            maxWidth={maxWidth}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
        >
            <DialogTitle id="responsive-dialog-title">{title}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <Typography variant={"subtitle1"}>{message}</Typography>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                {children}
                {!hideClose && (
                    <Button onClick={handleClose} color="secondary">
                        Close
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
}

export default ErrorDialog;
